import React from "react";
import Header from "../../layouts/Header";
import CallerRemarksSidebar from "./CallerRemarksSidebar";
import { Outlet } from "react-router-dom";
import "./collectionCallerRemarks.css";

const CollectionCallerRemarksLayout = () => {
  return (
    <div className="caller-layout">
      {/* SAME HEADER */}
      <Header />

      <div className="caller-body">
        {/* NEW SIDEBAR */}
        <CallerRemarksSidebar />

        {/* PAGE CONTENT */}
        <div className="caller-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default CollectionCallerRemarksLayout;
